import React, { useMemo } from 'react';
import { Image, ImageBackground, View } from 'react-native';
import CreditCardFrontImage from '~/assets/img/credit-card-front.png';
import HipercardImage from '~/assets/img/hipercard.png';
import AmexImage from '~/assets/img/amex.png';
import DinersImage from '~/assets/img/diners.png';
import EloImage from '~/assets/img/elo.png';
import MasterCardImage from '~/assets/img/masterCard.png';
import VisaImage from '~/assets/img/visa.png';
import { Text } from '~/components';

interface Props extends Omit<Checkout.CreditCard, 'document' | 'CVV'> {
  side: 'front' | 'rear';
  cardType: string | undefined;
}

const CardBanner = ({
  side,
  cardType,
  cardNumber,
  holderName,
  expiryDate,
}: Props) => {
  const cardFlag = useMemo(() => {
    switch (cardType) {
      case 'master':
      case 'mastercard':
        return MasterCardImage;
      case 'visa':
        return VisaImage;
      case 'diners':
      case 'diners-club':
        return DinersImage;
      case 'hipercard':
        return HipercardImage;
      case 'amex':
      case 'american-express':
        return AmexImage;
      case 'elo':
        return EloImage;
      default:
        return null;
    }
  }, [cardType]);

  if (side === 'front') {
    return (
      <ImageBackground
        resizeMethod="resize"
        resizeMode="stretch"
        className={'h-[200px] w-[355px] self-center'}
        source={CreditCardFrontImage}
      >
        {!!cardFlag && (
          <Image
            className="absolute top-[35px] right-[45px] z-10 w-[32px] h-[32px]"
            source={cardFlag}
            resizeMode="contain"
          />
        )}

        {String(cardNumber).length === 19 && (
          <Text className="absolute bottom-[85px] left-[45px]">{`Final ${String(
            cardNumber
          ).substring(15)}`}</Text>
        )}

        {!!holderName && (
          <Text className="absolute bottom-[55px] left-[45px] max-w-[255px] h-[20px] overflow-ellipsis overflow-hidden whitespace-nowrap">
            {holderName.toUpperCase()}
          </Text>
        )}

        {!!expiryDate && (
          <Text className="absolute bottom-[55px] right-[45px]">
            {expiryDate}
          </Text>
        )}
      </ImageBackground>
    );
  }

  return (
    <ImageBackground
      resizeMethod="resize"
      resizeMode="stretch"
      className={'h-[200px] w-[355px] self-center'}
      source={CreditCardFrontImage}
    >
      <View
        className={
          'absolute h-[30px] w-[296px] bg-black top-[35px] left-[30px] lg:left-[30px] lg:w-[295px]'
        }
      />

      <View className="absolute left-[28px] bg-gray-200 h-[25px] w-[130px] top-[80px] rounded-r-3xl items-end">
        <View className="h-[25px] w-[25px] border-2 border-white rounded-3xl items-center justify-center flex-row">
          <View className="w-[2px] h-[2px] bg-gray-600 rounded-lg" />
          <View className="w-[2px] h-[2px] bg-gray-600 rounded-lg mx-[2px]" />
          <View className="w-[2px] h-[2px] bg-gray-600 rounded-lg" />
        </View>
      </View>
    </ImageBackground>
  );
};

export default CardBanner;
